import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Indicator } from "@/components/ui/indicator";
import { asColor } from "@/utils/format";

/* Prop Types */
interface VideoMetricRowProps {
  label: string;
  score: number | null | undefined;
  nullLabel?: string;
}

/**
 * VideoMetricRow component
 *
 * Renders a single video sub-metric (Hook / Visual ease / Hold) as a label on the left and a
 * coloured dot + percentage score on the right. When score isn't a number yet (not yet computed
 * for this scene — the API may send this as null or simply omit the field), shows a neutral dot
 * and nullLabel instead — "Later" by default.
 */
export const VideoMetricRow = ({ label, score, nullLabel = "Later" }: VideoMetricRowProps) => {
  const hasScore = typeof score === "number";

  /* Render */
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-1">
        <span className="text-sm font-semibold">{label}</span>
        <InformationCircleIcon className="size-4 text-base-content/50" />
      </div>
      <div className="flex items-center gap-3">
        <Indicator color={hasScore ? asColor(score) : "#9ca3af"} size="small" />
        <span className="text-sm font-semibold whitespace-nowrap">{hasScore ? `${Math.round(score)}%` : nullLabel}</span>
      </div>
    </div>
  );
};
